"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M18.968 13.846a2.285 2.285 0 0 1 2.308 2.308c0 .738-.369 1.384-.923 1.846l.923 4.523a.439.439 0 0 1-.184.462c-.093.046-.185.092-.277.092-.093 0-.139 0-.185-.046l-1.662-.831-1.661.83c-.138.093-.37.047-.508-.045-.138-.093-.184-.277-.184-.462L17.538 18a2.272 2.272 0 0 1-.923-1.846c.046-1.292 1.061-2.308 2.354-2.308Zm-.553 4.57-.693 3.369 1.016-.508a.641.641 0 0 1 .415 0l1.016.508-.693-3.37c-.138 0-.323.047-.508.047-.184 0-.369-.047-.553-.047Zm-13.2 1.892h10.061c.277 0 .462.184.462.461s-.185.462-.462.462H4.292l.923-.923ZM18.968.923c.277 0 .462.185.462.462v.83l-.923.923V1.846h-9.23v5.077c0 .277-.185.462-.462.462H3.738v10.523l-.923.923V6.738c0-.046.046-.046.046-.092s.046-.046.046-.092l5.538-5.539h.047L8.538.97l.046-.046h10.384ZM8.815 17.538c.277 0 .461.185.461.462s-.184.462-.461.462H7.06l.923-.924h.83Zm10.153-2.769c-.784 0-1.384.6-1.384 1.385s.6 1.384 1.384 1.384c.785 0 1.385-.6 1.385-1.384 0-.785-.6-1.385-1.385-1.385ZM7.8 13.846l-.923.923H5.122c-.23 0-.415-.184-.461-.415v-.046c0-.277.184-.462.461-.462H7.8Zm7.477 0c.277 0 .462.185.462.462s-.185.461-.462.461h-4.523l.923-.923h3.6Zm4.154-7.754v6.37c0 .277-.185.461-.462.461-.276 0-.461-.184-.461-.461V7.015l.923-.923Zm-7.938 4.062-.924.923H5.123c-.23 0-.415-.185-.461-.415v-.047c0-.277.184-.461.461-.461h6.37Zm5.63 0c.277 0 .462.184.462.461s-.185.462-.462.462h-2.677l.923-.923h1.754Zm-1.938-3.692-.923.923h-2.677c-.23 0-.415-.185-.462-.416v-.046c0-.277.185-.461.462-.461h3.6Zm-6.83-3.97-3.97 3.97h3.97v-3.97ZM1.891 22.015c.092 0 .323 0 .415-.092L22.43 1.8a.502.502 0 0 0 0-.692.502.502 0 0 0-.692 0L1.568 21.23a.502.502 0 0 0 0 .692c0 .092.231.092.324.092Z",
    clipRule: "evenodd"
  })]
});